"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var FullscreenExit_exports = {};
__export(FullscreenExit_exports, {
  default: () => FullscreenExit_default
});
module.exports = __toCommonJS(FullscreenExit_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.41016 2.67188C8.55339 2.67188 8.67057 2.72396 8.76172 2.82812C8.86589 2.91927 8.91797 3.02995 8.91797 3.16016V6.91016C8.91797 7.39193 8.74219 7.80859 8.39062 8.16016C8.05208 8.4987 7.64193 8.66797 7.16016 8.66797H3.41016C3.27995 8.66797 3.16276 8.6224 3.05859 8.53125C2.96745 8.42708 2.92188 8.30339 2.92188 8.16016C2.92188 8.02995 2.96745 7.91927 3.05859 7.82812C3.16276 7.72396 3.27995 7.67188 3.41016 7.67188H7.16016C7.36849 7.67188 7.54427 7.60026 7.6875 7.45703C7.84375 7.30078 7.92188 7.11849 7.92188 6.91016V3.16016C7.92188 3.02995 7.96745 2.91927 8.05859 2.82812C8.16276 2.72396 8.27995 2.67188 8.41016 2.67188ZM12.5898 2.67188C12.7201 2.67188 12.8307 2.72396 12.9219 2.82812C13.026 2.91927 13.0781 3.02995 13.0781 3.16016V6.91016C13.0781 7.11849 13.1497 7.30078 13.293 7.45703C13.4492 7.60026 13.6315 7.67188 13.8398 7.67188H17.5898C17.7201 7.67188 17.8307 7.72396 17.9219 7.82812C18.026 7.91927 18.0781 8.02995 18.0781 8.16016C18.0781 8.30339 18.026 8.42708 17.9219 8.53125C17.8307 8.6224 17.7201 8.66797 17.5898 8.66797H13.8398C13.3581 8.66797 12.9414 8.4987 12.5898 8.16016C12.2513 7.80859 12.082 7.39193 12.082 6.91016V3.16016C12.082 3.02995 12.1276 2.91927 12.2188 2.82812C12.3229 2.72396 12.4466 2.67188 12.5898 2.67188ZM2.92188 12.3398C2.92188 12.1966 2.96745 12.0794 3.05859 11.9883C3.16276 11.8841 3.27995 11.832 3.41016 11.832H7.16016C7.64193 11.832 8.05208 12.0078 8.39062 12.3594C8.74219 12.6979 8.91797 13.1081 8.91797 13.5898V17.3398C8.91797 17.4701 8.86589 17.5872 8.76172 17.6914C8.67057 17.7826 8.55339 17.8281 8.41016 17.8281C8.27995 17.8281 8.16276 17.7826 8.05859 17.6914C7.96745 17.5872 7.92188 17.4701 7.92188 17.3398V13.5898C7.92188 13.3815 7.84375 13.2057 7.6875 13.0625C7.54427 12.9062 7.36849 12.8281 7.16016 12.8281H3.41016C3.27995 12.8281 3.16276 12.7826 3.05859 12.6914C2.96745 12.5872 2.92188 12.4701 2.92188 12.3398ZM12.082 13.5898C12.082 13.1081 12.2513 12.6979 12.5898 12.3594C12.9414 12.0078 13.3581 11.832 13.8398 11.832H17.5898C17.7201 11.832 17.8307 11.8841 17.9219 11.9883C18.026 12.0794 18.0781 12.1966 18.0781 12.3398C18.0781 12.4701 18.026 12.5872 17.9219 12.6914C17.8307 12.7826 17.7201 12.8281 17.5898 12.8281H13.8398C13.6315 12.8281 13.4492 12.9062 13.293 13.0625C13.1497 13.2057 13.0781 13.3815 13.0781 13.5898V17.3398C13.0781 17.4701 13.026 17.5872 12.9219 17.6914C12.8307 17.7826 12.7201 17.8281 12.5898 17.8281C12.4466 17.8281 12.3229 17.7826 12.2188 17.6914C12.1276 17.5872 12.082 17.4701 12.082 17.3398V13.5898Z",
      fill: "currentColor"
    }
  )
);
const SvgFullscreenExit = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var FullscreenExit_default = SvgFullscreenExit;
